import { render, staticRenderFns } from "./EditQnzlData.vue?vue&type=template&id=08c93551&scoped=true&"
import script from "./EditQnzlData.vue?vue&type=script&lang=js&"
export * from "./EditQnzlData.vue?vue&type=script&lang=js&"
import style0 from "./EditQnzlData.vue?vue&type=style&index=0&id=08c93551&prod&lang=less&scoped=true&"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c93551",
  null
  
)

export default component.exports